import React, {Component} from 'react';
import Alert from '../../components/Alert';
import { login } from '../../actions/authentication';
import { connect } from 'react-redux';
import './styles.css';

class Login extends Component {
  static isPublic = true;

  constructor(props) {
    super(props);
    this.state = {email: '', password: '', error: undefined};
    this._onChangeInput = this._onChangeInput.bind(this);
    this._onLogin = this._onLogin.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.token && nextProps.token.length) {
      this.props.history.push('/');
    }
  }

  _onChangeInput(property, event) {
    this.setState({[property]: event.target.value});
  }

  _onLogin() {
    this.setState({error: undefined});
    this.props.dispatch(login((error, json) => {
      if (error) {
        this.setState({error: error});
      }
    }, this.state));
  }

  _onKeyDown(event) {
    if (event.key === 'Enter' && this.state.email && this.state.password) {
      event.preventDefault();
      this._onLogin();
    }
  }

  render() {
    let disabled = !this.state.password || !this.state.email;

    return (
        <div className="Login">
          <div className="Login-Card">
            <div className="Login-Logo">
              <span className="Brand-Glyph"><i className="fa fa-suitcase" aria-hidden="true" /></span>
              Portal
            </div>
            <div className="Login-Sub">Sign in to manage your time off and reports.</div>

            <Alert error={this.state.error}/>

            <form onSubmit={e => e.preventDefault()}>
              <div className="Input">
                <label>Email</label>
                <input id="email" type="email" className="form-control" value={this.state.email}
                       onKeyDown={this._onKeyDown}
                       onChange={event => this._onChangeInput('email', event)}/>
              </div>
              <div className="Input">
                <label>Password</label>
                <input id="password" type="password" className="form-control" value={this.state.password}
                       onKeyDown={this._onKeyDown}
                       onChange={event => this._onChangeInput('password', event)}/>
              </div>
              <div className="Input" style={{paddingTop: '8px'}}>
                <button disabled={disabled} id="login" type="button" className="btn btn-primary btn-block" onClick={this._onLogin}>
                  Sign in
                </button>
              </div>
            </form>
          </div>
        </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: state.authentication.token,
  };
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/screens/Login/index.js